// SERVICES-001 Digital Marketing ads run by Adyvance (owner, 2026-10-23; D-053): the shop's Meta Ads and
// Google Ads pages (connection, ad wallet, results, ads, promote a product, add money) and the owner
// console's Digital Marketing section. Our own wording.
export const adsStrings = {
  back: "Digital Marketing",
  promote: "Promote a product",
  copy: "Copy",
  copied: "Copied",
  platforms: {
    meta: {
      title: "Meta Ads",
      lead: "Facebook and Instagram ads, run for you by the Adyvance team. Adyvance pays Meta; your ads are paid from your ad wallet.",
      connect: {
        title: "Share your Facebook Page",
        lead: "The Adyvance team runs your ads from Adyvance's Meta business account. You keep full ownership of your Page and can remove our access at any time.",
        link: "Facebook Page link",
        linkPh: "facebook.com/yourpage",
        handle: "Instagram username (optional)",
        confirm: "I'm an admin of this Page",
        share: "Share Page",
        shared: "Page shared with Adyvance",
        change: "Change Page",
        keep: "Keep this Page",
        invalid: "Paste the link of your Facebook Page, like facebook.com/yourpage.",
      },
      steps: {
        s1: "Share your Page link",
        s1Body: "Paste the link of the Facebook Page your customers know.",
        s2: "Approve Adyvance",
        s2Body:
          "In Meta Business Suite, open Settings → Requests and approve the partner request from {name}.",
        s3: "We run your ads",
        s3Body: "Promote a product here. Results show on this page.",
      },
      states: {
        submitted: "Shared · waiting for Adyvance",
        requested: "Approve the request in Meta Business Suite",
        connected: "Connected",
        failed: "Couldn't connect",
        removed: "Removed",
      },
      help: {
        submitted:
          "The Adyvance team sends a partner request to your Page within one working day. You'll approve it in Meta Business Suite.",
        requested:
          "Open Meta Business Suite → Settings → Requests and approve the partner request from {name}.",
        connected: "Adyvance can run ads for this Page.",
        failed: "Check the Page link and that you're its admin, then share it again.",
        removed: "Share your Page again to run ads.",
      },
      business: "Adyvance Business ID",
      open: "Open Meta Business Suite",
      sync: "Results from Meta · updated {time}",
    },
    google: {
      title: "Google Ads",
      lead: "Search, Shopping and YouTube ads, run for you by the Adyvance team. Adyvance pays Google; your ads are paid from your ad wallet.",
      connect: {
        title: "Start Google Ads",
        lead: "The Adyvance team opens a Google Ads account for your store under Adyvance's manager account and runs your ads. You don't need your own Google Ads account or card.",
        link: "Website",
        linkPh: "yourstore.com",
        handle: "YouTube channel (optional)",
        confirm: "This is my store's website",
        share: "Start Google Ads",
        shared: "Sent to Adyvance",
        change: "Change details",
        keep: "Keep these details",
        invalid: "Check the website address, like yourstore.com.",
      },
      steps: {
        s1: "Tell us your website",
        s1Body: "Your store's address, and your YouTube channel if you have one.",
        s2: "We open your account",
        s2Body: "Adyvance opens a Google Ads account for you under {name}. Nothing to approve.",
        s3: "We run your ads",
        s3Body: "Promote a product here. Results show on this page.",
      },
      states: {
        submitted: "Sent · waiting for Adyvance",
        requested: "Setting up your account",
        connected: "Ready",
        failed: "Couldn't set up",
        removed: "Removed",
      },
      help: {
        submitted: "The Adyvance team opens your Google Ads account within one working day.",
        requested:
          "The Adyvance team is setting up your Google Ads account. Nothing to do on your side.",
        connected: "Adyvance can run Google ads for this store.",
        failed: "Check the website address, then send it again.",
        removed: "Send your website again to run Google ads.",
      },
      shopping: "Show my products on Google Shopping",
      shoppingHint: "Adyvance gives Google your store's product feed.",
      shoppingOn: "Products on Shopping",
      business: "Adyvance manager account",
      open: "Open Google Ads",
      sync: "Results from Google Ads · updated {time}",
    },
  },
  wallet: {
    title: "Adyvance Wallet",
    add: "Top up",
    inAds: "In ads",
    added: "Added",
    pending: "{count} top-up waiting",
    hint: "Ads are paid from your Adyvance Wallet, the same balance as SMS, plans and imports. What an ad doesn't spend comes back.",
  },
  kpi: {
    spend: "Spent",
    reach: "Reach",
    impressions: "Impressions",
    clicks: "Clicks",
    ctr: "Click rate",
    cpc: "Cost per click",
    results: "Results",
    cpr: "Cost per result",
    cpm: "Per 1,000 views",
  },
  range: { d7: "7 days", d30: "30 days", d90: "90 days" },
  chart: {
    title: "Daily results",
    metric: {
      spend: "Spent",
      results: "Results",
      clicks: "Clicks",
      reach: "Reach",
      impressions: "Impressions",
    },
    empty: "No results yet. They show here once an ad is running.",
    table: "Table",
    chart: "Chart",
    day: "Day",
  },
  manual: "Results are added by the Adyvance team until the platform's reporting is connected.",
  tabs: { ads: "Ads", wallet: "Wallet" },
  list: {
    emptyTitle: "No ads yet",
    emptyBody: "Promote a product and the Adyvance team sets up the ad for you.",
    emptyNotConnected: "Finish the step above, then promote your first product.",
    product: "Ad",
    spent: "Spent",
    results: "Results",
    status: "Status",
    perDay: "{amount}/day · {days} days",
    of: "of {amount}",
    cancel: "Cancel ad",
    cancelled: "Ad cancelled. {amount} is back in your wallet.",
    teamNote: "Adyvance team",
    ends: "Ends {date}",
    refunded: "{amount} returned",
  },
  goals: {
    messages: "Messages",
    sales: "Sales",
    traffic: "Website visits",
    calls: "Calls",
    awareness: "Awareness",
  },
  goalHints: {
    meta: {
      messages: "More chats on Messenger and WhatsApp",
      sales: "Purchases on your website",
      traffic: "More people open your product page",
      calls: "Calls to your shop",
      awareness: "Reach as many people as possible",
    },
    google: {
      messages: "More chats",
      sales: "Shopping and search ads that sell",
      traffic: "Search ads that bring visitors",
      calls: "Ads with a call button",
      awareness: "YouTube and Display ads",
    },
  },
  resultNames: {
    messages: "chats",
    sales: "purchases",
    traffic: "link clicks",
    calls: "calls",
    awareness: "people reached",
  },
  states: {
    review: "In review",
    live: "Live",
    paused: "Paused",
    ended: "Ended",
    rejected: "Rejected",
    cancelled: "Cancelled",
  },
  places: {
    all: "All Nepal",
    kathmandu_valley: "Kathmandu Valley",
    pokhara: "Pokhara",
    chitwan: "Chitwan",
    butwal: "Butwal",
    biratnagar: "Biratnagar",
    dharan: "Dharan",
    birgunj: "Birgunj",
    nepalgunj: "Nepalgunj",
    dhangadhi: "Dhangadhi",
  },
  promoteForm: {
    lead: "Pick a product and a budget. The Adyvance team makes the ad and starts it after review.",
    product: "Product",
    search: "Search your products",
    noProducts: "No products found.",
    goal: "Goal",
    budget: "Budget",
    daily: "Per day",
    days: "Days",
    audience: "Who sees it",
    age: "Age",
    ageTo: "to",
    gender: { all: "Everyone", women: "Women", men: "Men" },
    note: "Notes for the team",
    notePh: {
      meta: "Offer, price, colours, what makes it special…",
      google: "Words people search for, offer, price, what makes it special…",
    },
    shoppingOff: "Sales on Google work best with your products on Shopping. Turn it on above.",
    min: "Smallest daily budget: {amount}",
    adBudget: "Ad budget",
    fee: "Service fee ({percent}%)",
    total: "From wallet",
    after: "Wallet after",
    short: "Add {amount} to your wallet to send this ad.",
    pick: "Pick a product to promote.",
    submit: "Send for review",
    sent: "Ad sent for review. {amount} was taken from your wallet.",
    close: "Close",
  },
  topup: {
    title: "Add money to the ad wallet",
    lead: "Pay Adyvance by QR or bank transfer and upload the receipt. The money shows once Adyvance confirms it.",
    amount: "Amount",
    pay: "How you pay",
    methods: { qr: "QR", bank: "Bank", esewa: "eSewa", khalti: "Khalti" },
    soon: "Soon",
    scan: "Scan and pay {amount}",
    noQr: "Adyvance hasn't added its QR yet. Pay by bank transfer.",
    noBank: "Adyvance hasn't added its bank details yet.",
    bank: { bank: "Bank", name: "Account name", number: "Account number" },
    reference: "Transaction ID",
    referencePh: "From your bank or wallet app",
    upload: "Upload receipt",
    uploading: "Uploading…",
    change: "Change",
    total: "You pay",
    need: "Upload the receipt or type the transaction ID.",
    submit: "Send for confirmation",
    sent: "Sent. Adyvance will confirm your payment soon.",
    min: "At least {amount}",
  },
  walletTab: {
    topups: "Top-ups",
    date: "Date",
    amount: "Amount",
    method: "Paid by",
    reference: "Transaction ID",
    status: "Status",
    history: "Wallet history",
    empty: "Nothing here yet.",
    states: { submitted: "Waiting", confirmed: "Added", rejected: "Rejected" },
    kinds: { topup: "Top-up", grant: "Adjustment", ad: "Ad budget", refund: "Returned" },
  },
  errors: {
    balance: "Your ad wallet doesn't have enough money for this. Add money first.",
    connection: "Finish connecting this platform first.",
    online: "eSewa and Khalti aren't available yet. Pay by QR or bank transfer.",
    budget: "The daily budget is below the smallest allowed.",
  },
  console: {
    title: "Digital Marketing",
    lead: "Shops' Meta and Google ads: their connections, the ads they asked for, their wallet top-ups and your settings.",
    allPlatforms: "All",
    tiles: {
      review: "Ads to review",
      connections: "Accounts to connect",
      topups: "Top-ups to confirm",
      held: "Money in shop wallets",
    },
    tabs: {
      ads: "Ads",
      connections: "Accounts",
      topups: "Top-ups",
      wallets: "Wallets",
      settings: "Settings",
    },
    open: "To do",
    all: "All",
    shop: "Shop",
    store: "Store",
    syncOn: "{platform} reporting connected · last read {time}",
    syncOff: "{platform} reporting isn't connected: enter its results by hand.",
    emptyAds: "No ads here.",
    emptyConnections: "No accounts here.",
    emptyTopups: "No top-ups here.",
    emptyWallets: "No shop has an ad wallet yet.",
    ad: {
      audience: "Audience",
      goal: "Goal",
      budget: "Budget",
      fee: "Fee",
      charged: "Taken from wallet",
      spent: "Spent",
      note: "Shop's note",
      externalId: { meta: "Meta campaign ID", google: "Google Ads campaign ID" },
      externalHint: {
        meta: "From Ads Manager. Needed to read results from Meta.",
        google: "From Google Ads (Campaigns → ID column). Needed to read results from Google.",
      },
      staffNote: "Note to the shop (optional)",
      approve: "Approve and start",
      reject: "Reject and refund",
      pause: "Pause",
      resume: "Resume",
      end: "End and refund the rest",
      link: "Save campaign ID",
      endHint: "Returns {amount}: what wasn't spent, with its fee.",
      done: "Ad updated",
      results: "Results by day",
      resultsHint: "Copy from the platform's reports. Saving a day again replaces it.",
      day: "Day",
      save: "Save results",
      saved: "Results saved",
      addDay: "Add day",
      ages: "{min}–{max}",
    },
    connection: {
      link: { meta: "Page link", google: "Website" },
      handle: { meta: "Instagram", google: "YouTube" },
      accountId: { meta: "Page ID", google: "Google Ads customer ID" },
      name: { meta: "Page name", google: "Account name" },
      howTo: {
        meta: "In Meta Business Suite: Settings → Accounts → Pages → Add → Request access to a Page. Paste the Page ID and ask for ads and insights access.",
        google:
          "In Adyvance's Google Ads manager account: Accounts → + → Create new account (Nepal, NPR or your billing currency, Adyvance's billing). Paste the new customer ID. For Shopping, add the product feed in Merchant Center and link it to the account.",
      },
      feed: "Product feed",
      requested: { meta: "Request sent", google: "Setting up" },
      connected: "Mark connected",
      failed: "Couldn't connect",
      remove: "Remove",
      note: "Note to the shop",
      done: "Account updated",
    },
    topupDone: "Top-up updated",
    confirm: "Confirm and add money",
    reject: "Reject",
    note: "Note (optional)",
    receipt: "View receipt",
    noReceipt: "No receipt",
    adjust: "Add or take money",
    adjustTitle: "Wallet of {shop}",
    adjustAmount: "Amount in Rs (minus to take)",
    adjustNote: "Reason",
    adjustSave: "Save",
    adjusted: "Wallet updated",
    balance: "Balance",
    toppedUp: "Ever added",
    inAds: "In ads",
    settings: {
      business: { meta: "Meta Business Portfolio", google: "Google Ads manager account" },
      businessLead: {
        meta: "Shown to shops so they know whose partner request to approve.",
        google: "The manager account that holds every shop's Google Ads account.",
      },
      businessId: { meta: "Business ID", google: "Manager account ID" },
      businessName: "Name",
      fee: "Fee (%)",
      minDaily: "Min. per day (Rs)",
      currency: "Currency",
      rate: "Rs per 1 {currency}",
      save: "Save settings",
      saved: "Settings saved",
    },
  },
} as const;
